(function () {
  function initialiseMasonry(gallery) {
    if (gallery.dataset.galleryLayout !== 'masonry') return;

    var grid = gallery.querySelector('.yb-photo-gallery__grid');
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.yb-photo-gallery__item'));
    var frame = null;
    var lastWidth = 0;

    if (!grid || !items.length) return;

    function layoutMasonry() {
      frame = null;

      var styles = window.getComputedStyle(gallery);
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var columnProperty = isMobile ? '--yb-gallery-columns-mobile' : '--yb-gallery-columns';
      var columns = Math.max(1, parseInt(styles.getPropertyValue(columnProperty), 10) || 1);
      var gap = Math.max(0, parseFloat(styles.getPropertyValue('--yb-gallery-gap')) || 0);
      var gridWidth = grid.clientWidth;
      var itemWidth = (gridWidth - gap * (columns - 1)) / columns;
      var columnHeights = Array(columns).fill(0);

      items.forEach(function (item) {
        item.style.width = itemWidth + 'px';

        var shortestHeight = Math.min.apply(Math, columnHeights);
        var columnIndex = columnHeights.indexOf(shortestHeight);
        var left = columnIndex * (itemWidth + gap);

        item.style.transform = 'translate3d(' + left + 'px, ' + shortestHeight + 'px, 0)';
        columnHeights[columnIndex] = shortestHeight + item.getBoundingClientRect().height + gap;
      });

      var tallestColumn = Math.max.apply(Math, columnHeights);
      grid.style.height = Math.max(0, tallestColumn - gap) + 'px';
      gallery.dataset.masonryReady = 'true';
    }

    function scheduleLayout() {
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(layoutMasonry);
    }

    items.forEach(function (item) {
      var image = item.querySelector('img');
      if (image && !image.complete) image.addEventListener('load', scheduleLayout, { once: true });
    });

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function (entries) {
        var newWidth = entries[0].contentRect.width;
        if (Math.abs(newWidth - lastWidth) < 1) return;
        lastWidth = newWidth;
        scheduleLayout();
      });

      resizeObserver.observe(grid);
      gallery.ybGalleryResizeObserver = resizeObserver;
    } else {
      window.addEventListener('resize', scheduleLayout);
    }

    scheduleLayout();
  }

  function initialiseGallery(gallery) {
    if (!gallery || gallery.dataset.galleryInitialised === 'true') return;

    var triggers = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-trigger]'));
    var dialog = gallery.querySelector('[data-gallery-dialog]');
    var dialogImage = gallery.querySelector('[data-gallery-image]');
    var caption = gallery.querySelector('[data-gallery-caption]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var previousButton = gallery.querySelector('[data-gallery-previous]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var closeButton = gallery.querySelector('[data-gallery-close]');
    var currentIndex = 0;

    if (!triggers.length || !dialog || !dialogImage) return;

    gallery.dataset.galleryInitialised = 'true';
    initialiseMasonry(gallery);

    function updatePhoto(index) {
      currentIndex = (index + triggers.length) % triggers.length;

      var trigger = triggers[currentIndex];
      var imageCaption = trigger.dataset.photoCaption || '';

      dialogImage.src = trigger.dataset.fullSrc;
      dialogImage.alt = trigger.dataset.photoAlt || '';
      caption.textContent = imageCaption;
      caption.hidden = imageCaption === '';
      counter.textContent = String(currentIndex + 1) + ' / ' + String(triggers.length);
    }

    function openPhoto(index) {
      updatePhoto(index);

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closePhoto() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openPhoto(index);
      });
    });

    previousButton.addEventListener('click', function () {
      updatePhoto(currentIndex - 1);
    });

    nextButton.addEventListener('click', function () {
      updatePhoto(currentIndex + 1);
    });

    closeButton.addEventListener('click', closePhoto);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closePhoto();
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        updatePhoto(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        updatePhoto(currentIndex + 1);
      }
    });
  }

  function initialiseAll(scope) {
    var galleries = scope.querySelectorAll('[data-yoel-photo-gallery]');
    Array.prototype.forEach.call(galleries, initialiseGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
